<ez-main-layout>
  <ez-banner>
    <span ngProjectAs="title">Willkommen</span>
    <span ngProjectAs="subtitle">Ihr persönlicher Zugangscode</span>
  </ez-banner>
  <p>Bitte geben Sie im nachfolgenden Feld Ihren persönlichen Zugangscode aus dem Anschreiben ein.</p>
  <form class="form-body" [formGroup]="form" (ngSubmit)="onSubmit()">
    <label class="text--bold" for="personalAccessToken"
      >Persönlicher Zugangscode<span aria-hidden="true">&nbsp;*</span></label
    >
    <input
      id="personalAccessToken"
      aria-label="Fokussieren Sie dieses rechteckige Eingabefeld, um Ihren persönlichen Zugangscode einzugeben."
      type="password"
      placeholder="Bitte Zugangscode eingeben"
      [formControlName]="CONTROL_NAME"
      [autocomplete]="AutocompleteValue.OFF"
      [class.error]="errorMessage()"
      [attr.aria-required]="true"
    />
    @if (errorMessage(); as _message) {
      <span class="error-message">{{ _message }}</span>
    }
    <ez-required-fields-hint></ez-required-fields-hint>
    <ez-button
      [disabled]="!(form && form.valid)"
      [loading]="submitPersonalAccessTokenIsLoading()"
      [altText]="'Drücken Sie diesen rechteckigen, orangen Button unterhalb des Eingabefeldes zum Senden Ihres persönlichen Zugangscodes.'"
      class="submit-button"
      maxWidth="100px"
      label="Senden"
    ></ez-button>
  </form>
</ez-main-layout>
